import nbs from "./ss1.png";
import nbs2 from "./ss2.png";
import nbs3 from "./ss3.png";
import nbs4 from "./ss4.png";

const nbsImages = [nbs2, nbs, nbs3, nbs4];

export default nbsImages;
